<template>
  <transition :duration="200" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div v-if="show" class="scroll-to-top cursor-pointer no-print" :class="{'no-footer': noFooter}" @click="scrollToTop">
        <div class="arrow-container">
          <i class="arrow fal fa-angle-up" tabindex="0" @keypress.enter.space="scrollToTop"></i>
        </div>
    </div>
  </transition>
</template>

<script>

import breakpoints from '@/libs/breakpoints'

export default {
  props: {
    emit: Boolean
  },
  data: function () {
    return {
      show: false,
      timer: null
    }
  },
  created: function () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    autoHide: function () {
      return breakpoints.isMobile()
    },
    noFooter: function () {
      return !!(this.$route && this.$route.meta.hideFooter)
    }
  },
  methods: {
    handleScroll () {
      this.show = window.pageYOffset > 400
      if (this.show && this.autoHide) {
        if (this.timer) {
          clearTimeout(this.timer)
        }

        this.timer = setTimeout(() => {
          this.show = false
        }, 3000)
      }
    },
    scrollToTop () {
      if (this.emit) {
        return this.$emit('click')
      }

      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .scroll-to-top {
    text-align: center;
    position: fixed;
    bottom: 7%;
    right: 3%;
    background-color: $primary;
    border-radius: 50%;
    width: 2.9rem;
    height: 2.9rem;
    border: 0px 2px 2px 0px rgba(0,0,0,0.22);
    transition: 0.2s;
    color: white;
    font-weight: 700;
    opacity: 0.8;
    z-index: 10;
    &:hover {
      opacity: 1;
    }
    @include touch {
      box-shadow: 0px 3px 3px 0px rgba(0,0,0,0.22);
      bottom: 8%;
    }
    @include mobile {
      bottom: 55px; // engagement-bar (50px) + negative space (5px)
    }

    &.no-footer {
      bottom: 2%;
    }
  }
  .arrow-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    height: 100%;
    margin-top: auto;
    margin-bottom: auto;
  }
  .arrow {
    font-size: 2.1rem;
    line-height: 0;
    opacity: 0.9;
  }
  .arrow-text {
    font-size: 0.95rem;
    line-height: 0;
  }
</style>
